import { Extent } from 'ol/extent';

import { IRangeTrace, IScale } from 'features/seismic/stores/useSeismicStore';
import { SeismicCalculator } from './SeismicCalculator';
import { ISurveyMetadata } from '../interfaces/ISurveyMetadata';

export class SeismicCalculator2DUnIndexed extends SeismicCalculator {
    calculateExtent (surveyMetadata: ISurveyMetadata, scale: IScale, rangeTrace: IRangeTrace) {
        const minTrace = rangeTrace.initial;
        const totalTraces = rangeTrace.end;

        const minX = minTrace;
        const minY = (surveyMetadata.Header?.SamplesPerTrace ?? 0) * -1 * scale.y;
        const maxX = minTrace + (totalTraces * scale.x);
        const maxY = 0;

        const extent = [minX, minY, maxX, maxY];
        return extent;
    };

    calculateCenter(extent: Extent, surveyMetadata: ISurveyMetadata, scale: IScale, rangeTrace: IRangeTrace) {
        const x = super.calculateCenterX(extent);
        const y = super.calculateCenterY((surveyMetadata.Header?.SamplesPerTrace ?? 0), scale.y);

        return [x, y];
    }

    getMaxTrace (surveyMetadata: ISurveyMetadata) {
        return surveyMetadata?.Header?.NumberOfTraces;
    }

    getInitialRangeTrace(surveyMetadata: ISurveyMetadata):IRangeTrace {
        return {
            initial: 1,
            end: 1000
        };
    }

    getTotalTraces(surveyMetadata: ISurveyMetadata): number {
        return surveyMetadata?.Header?.NumberOfTraces;
    }
}